import { coerceBooleanProperty, coerceNumberProperty } from '@angular/cdk/coercion';
import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, Host, HostBinding, Input, Optional, Self } from '@angular/core';
import { MatBadge } from '@angular/material/badge';

@Component({
  selector: 'mat-user-picture',
  templateUrl: './mat-user-picture.component.html',
  styleUrls: ['./mat-user-picture.component.scss']
})
export class MatUserPictureComponent implements AfterViewInit, AfterViewChecked {

	badgeRect: {width?: number, height?: number, top?: number, left?: number} = {};
	maskId: string = '';
	
	@Input() src: string = null;

	public _size: number = 40;
	@Input()
	get size() { return this._size; }
	set size(value: any) { 
		this._size = coerceNumberProperty(value);
		this.height = this._size;
	}

	_disabled: boolean = false;
	@Input()
	get disabled() { return this._disabled; }
	set disabled(value: any) { this._disabled = coerceBooleanProperty(value); }

	@HostBinding('style.height.px') height: number = this._size;

	constructor(@Host() @Self() @Optional() private badge: MatBadge,
				private changeDetectorRef: ChangeDetectorRef) {}

	ngAfterViewChecked () {
		this.changeDetectorRef.detectChanges();
	}

	ngAfterViewInit () {

		this.maskId = `mask-${Date.now().toString(36)}`;

		if(this.badge?.getBadgeElement()) {

			const width: number = this.badge.getBadgeElement().offsetWidth;
			const height: number = this.badge.getBadgeElement().offsetHeight;
			const left: number = (width / 2) + (this.badge.isAfter ? (this.size - width + 6) :  -6);
			const top: number =  (height / 2) + (this.badge.isAbove ? (this.size - height + 6) : -6);
			
			this.badgeRect = {width, height, top, left};
		}
	}
}
